import { useState, useCallback } from "react"
import { Navigate } from "react-router-dom";
import { API_ROOT } from "../../AppConfig/app-config";

export default function Logout() {
    const [loggedOut, setLoggedOut] = useState(false);
    const [message, setMessage] = useState(null);

    const handleLogout = useCallback((event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const object = {};
        formData.forEach(function(value, key){
            object[key] = value;
        });

        fetch(`${API_ROOT}/logout`, {
            credentials: 'include',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(object)
        })
        .then(d => {
            console.log("Logged Out");
            setLoggedOut(true);
        })
        .catch(error => {
            console.error("Logout error:", error);
            setMessage("Logout failed. Please try again.");
        });
    }, []);

    if(loggedOut === true){
        return(
            <div className=" container">
                <p>{message}</p>
                <Navigate to="/" />
            </div>
        );
    }

    return(
        <div>
            <form method="/post" onSubmit={handleLogout}>
                <button type="submit">Logout</button>
            </form>
        </div>
    );
}
